import { Box } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import { ChequeReturnReducerAction } from "../Store/ChequeReturnReducer";
import ChequeReturnFilter from "./ChequeReturnFilter";
import ChequeReturnList from "./ChequeReturnList";

const ChequeReturn = () => {
  //Selectors from redux store
  const showCheckReturnList = useSelector(
    (state) => state.chequeReturn.showCheckReturnList
  );

  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <ChequeReturnFilter />
        {showCheckReturnList && <ChequeReturnList />}
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};

export default ChequeReturn;
